import { Component, Input, OnInit, Output, EventEmitter, output, inject } from '@angular/core';
import { CommonService, CommonHttpService } from '../../../shared/services';
import { ConfirmationService } from 'primeng/api';
import { SpinnerService } from '../../../shared/services/spinner.service';
import { ReportType } from '../../report-details/interfaces/report-details.interface';
import { Tourservice } from '../../../shared/services/tourservice';

@Component({
  selector: 'bi-report-item',
  standalone: false,
  templateUrl: './report-item.component.html',
  styleUrl: './report-item.component.scss',
  providers: [ConfirmationService]
})
export class ReportItemComponent implements OnInit {
  private tour = inject(Tourservice); //Take a Tour
  @Input() reportItem: any;
  @Input() module: any;
  @Input() currentTab!: number;
  @Input() sectionId!: any;
  @Input() selectedTab!: any;
  updateFavourite = output<any>();
  updateUntag = output<any>();
  deleteReport = output<any>();
  refreshReportsList = output<any>();
  visible1: boolean = false;//reportt security settings
  visible2: boolean = false;//Schedule Report Automation 
  items!: any[];
  isDeleting: boolean = false; // Track delete operation loading state
  reportType = ReportType;

  constructor(private _commonService: CommonService,
    private _commonHttpService: CommonHttpService,
    private confirmationService: ConfirmationService,
    private spinnerService: SpinnerService
  ) {

  }

  ngOnInit(): void {
    this.updateMenuItems();

    
 

  }

  updateMenuItems() {

    this.items = [
      {
        label: 'Share Report',
        image: 'assets/images/share-icon-ol.svg',
        command: () => {
          this._commonService.reportLevelSecurityData = this.reportItem;
          this._commonService.showReportLevelSecurity();
          this.refreshReportsList.emit(this.selectedTab);
        }
      },
      {
        label: (this.reportItem?.isTaggedReport) ? 'UnTag Report' : ' Tag Report',
        image: 'assets/images/tag-icon-light.svg',
        command: () => {
          let isTaggedReport = (this.currentTab == 0) ? 0 : 1;
          this.reportItem = Object.assign(this.reportItem, { isTaggedReport: this.reportItem?.isTaggedReport });
          this._commonHttpService.tagAndUntagReport(this.reportItem).subscribe((res: any) => {
            if (res.status === 1) {
              // this._commonHttpService.repo(res.message, 'Success', Severity.success);
              if (isTaggedReport == 0) {
                this.updateUntag.emit({ item: this.reportItem, sectionId: this.sectionId });
              }
              // Emit event to refresh the reports list
              this.refreshReportsList.emit(this.selectedTab);
            }
          });
        }
      },
      {
        label: 'Schedule Report',
        image: 'assets/images/scheduledReports-icon-light.svg',
        command: () => {
          this.reportDetails(this.reportItem, this.currentTab == 2);
          this.refreshReportsList.emit(this.selectedTab);
        }
      },
      // Only add delete option if it's not an admin report
      ...(this.reportItem.isAdminReport !== 1 && (this.reportItem.deleteOwnReport)) ? [{
        label: this.isDeleting ? 'Delete' : 'Delete',
        image: this.isDeleting ? 'assets/images/spinner-icon.svg' : 'assets/images/delete-icon.svg',
        command: () => {
          if (!this.isDeleting) {
            this.confirmDelete();
          }
        },
        disabled: this.isDeleting
      }] : []
    ];
    if (this.currentTab == 1) {
      this.items.splice(3, 1);
    }
    if (![0, 1].includes(this.currentTab) || this.reportItem?.isAdminReport == 0 || this.reportItem?.childReport == 1) {
      this.items.splice(1, 1);
    }
  }

  /**
   * Dynamically generates menu items based on user permissions and report properties
   */
  getMenuItems(): any[] {
    const menuItems: any[] = [];

    // Share Report - Show if user can share
     if ((parseInt(this.reportItem?.loggedInUserId) == parseInt(this.reportItem?.createdByUser?.id))) {
    menuItems.push({
      label: 'Share Report',
      image: 'assets/images/share-icon-ol.svg',
      command: () => {
        this._commonService.showReportLevelSecurity();
      }
    });
    }

    // Tag/Untag Report - Show based on current tab and permissions
    if ([0, 1].includes(this.currentTab) && this.reportItem?.isAdminReport == 1) {
      menuItems.push({
        label: (this.reportItem?.isTaggedReport) ? 'UnTag Report' : 'Tag Report',
        image: 'assets/images/tag-icon-light.svg',
        command: () => {
          let isTaggedReport = (this.reportItem?.isTaggedReport == 0) ? 1 : 0;
          this.reportItem = Object.assign(this.reportItem, { isTaggedReport: isTaggedReport });
          this._commonHttpService.tagAndUntagReport(this.reportItem).subscribe((res: any) => {
            if (res.status === 1) {
              if (isTaggedReport == 0) {
                if (this.currentTab == 0) {
                  this.updateUntag.emit({ item: this.reportItem, sectionId: this.sectionId });
                }
                // Emit event to refresh the reports list
                this.refreshReportsList.emit(this.selectedTab);
              }
            }
          });
        }
      });
    }

    // Schedule Report - Show if user can schedule
    if (this.reportItem.canSchedule !== false) {
      menuItems.push({
        label: 'Schedule Report',
        image: 'assets/images/scheduledReports-icon-light.svg',
        command: () => this._commonService.showScheduleReport()
      });
    }

    // Edit Report - Show if user can edit and report is not archived
    if (this.reportItem.canEdit && this.reportItem.status !== 'archived') {
      menuItems.push({
        label: 'Edit Report',
        image: 'assets/images/edit-icon.svg',
        command: () => this.editReport()
      });
    }

    // Duplicate Report - Show if user can create reports
    if (this.reportItem.canCreate) {
      menuItems.push({
        label: 'Duplicate Report',
        image: 'assets/images/duplicate-icon.svg',
        command: () => this.duplicateReport()
      });
    }

    // Export Report - Show if user can export
    if (this.reportItem.canExport !== false) {
      menuItems.push({
        label: 'Export Report',
        image: 'assets/images/export-icon.svg',
        command: () => this.exportReport()
      });
    }

    // Delete Report - Show if user can delete and not in tagged tab
    if (this.reportItem.canDelete && this.currentTab !== 1 && (this.reportItem.isTaggedReport !== 1 || this.reportItem.isAdminReport !== 1)) {

      menuItems.push({
        label: 'Delete',
        image: 'assets/images/delete-icon.svg',
        command: () => {
          this.deleteReport.emit({ reportItem: this.reportItem, sectionId: this.sectionId });
          this._commonHttpService.deleteReport(this.reportItem.id).subscribe((res: any) => {
            if (res.status === 1) {
              this.deleteReport.emit({ reportItem: this.reportItem, currentTab: this.currentTab });
            }
          });
        }
      });
    }

    return menuItems;
  }

  /**
   * This method is used to toggle the favorite 
   * @param reportItem it holds the current report item
   */
  toggleFavourite(reportItem: any) {
    if (!reportItem) {
      console.error('Report item is undefined');
      return;
    }
    let isFavourite = (reportItem.isFavourite == 1) ? 0 : 1;
    //let userId = (reportItem.userId) ? reportItem.userId : 0;
    let data = {
      id: reportItem.favouriteReports && reportItem.favouriteReports.length > 0 ? reportItem.favouriteReports[0].id : null,
      isFavourite: isFavourite,
      reportId: this.currentTab == 2 ? reportItem.savedReportId : reportItem.id,
      reportFrom: reportItem.reportFrom
    };

    this._commonHttpService.updateFavourite(data).subscribe((res: any) => {
      if (res.status === 1) {
        this.reportItem.isFavourite = isFavourite;
        this.updateFavourite.emit(this.reportItem);
        this.refreshReportsList.emit(this.selectedTab);
      }
    });
  }
  reportDetails(reportItem: any, isScheduledReport: boolean = false) {
    // reportItem.isScheduledReport = isScheduledReport;
    reportItem.currentTab = this.currentTab;
    this._commonService.scheduleReportData = reportItem;
    this._commonService.showScheduleReport();
  }

  /**
   * Edit report method
   */
  editReport() {
    // Implementation for editing report
    console.log('Edit report:', this.reportItem.id);
  }

  /**
   * Duplicate report method
   */
  duplicateReport() {
    // Implementation for duplicating report
    console.log('Duplicate report:', this.reportItem.id);
  }

  /**
   * Export report method
   */
  exportReport() {
    // Implementation for exporting report
    console.log('Export report:', this.reportItem.id);
  }

  confirmDelete() {
    const reportName = this.reportItem.reportName;
    const confirmMessage = `Are you sure you want to delete "${reportName}"?`;
    this.confirmationService.confirm({
      message: confirmMessage,
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      header: 'Delete Report Confirmation',
      acceptButtonStyleClass: 'p-button-danger p-component',
      rejectButtonStyleClass: 'p-button-secondary p-component p-button-outlined',

      accept: () => {
        this.performDelete();
      },
      reject: () => {
        // User cancelled the deletion
        console.log('Delete cancelled by user');
      }
    });
  }

  private performDelete(): void {
    // User confirmed deletion
    this.isDeleting = true;
    this.updateMenuItems(); // Update menu to show loading state
    
    let params: any = { id: this.reportItem.id, sectionId: this.sectionId, currentTab: this.currentTab };

    this.spinnerService.withSpinner(
      this._commonHttpService.deleteReport(params),
      'Deleting report...'
    ).subscribe({
      next: (res: any) => {
        this.isDeleting = false;
        this.updateMenuItems(); // Update menu to remove loading state
        if (res.status === 1) {
          // Emit delete event after successful deletion
          this.deleteReport.emit({ reportItem: this.reportItem, sectionId: this.sectionId, currentTab: this.currentTab });
          // Emit event to refresh the reports list
          this.refreshReportsList.emit(this.selectedTab);
        }
      },
      error: (error) => {
        this.isDeleting = false;
        this.updateMenuItems(); // Update menu to remove loading state
        console.error('Error deleting report:', error);
      }
    });
  }

}
